import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HashRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { createStore } from "redux";
import RootReducer from "./Reducers";
//local
export const serverBaseUrl = "https://test-prod-api.dubuddy.in/"
// export const serverBaseUrl="https://test-prod-api.dubuddy.in/";
// export const serverBaseUrl="http://localhost:8080/";
export const fileBaseUrl =
  false && process.env.NODE_ENV === "development"
    ? "https://d1029ri9zcztl7.cloudfront.net/"
    : "https://d2dn8tqui3vt36.cloudfront.net/";
//server
// export const serverBaseUrl="https://api.dubuddy.in/";
export const serverApiUrl = serverBaseUrl + "api/v1/";
export const serverNewApiUrl = process.env.NODE_ENV === "development" ? "https://test-prod-api.dubuddy.in/api/v1/" : "https://prod-api.dubuddy.in/api/v1/";

export const serverNodeApiUrl = process.env.NODE_ENV === "development" ? "https://prod-api.dubuddy.in/" : "https://prod-api.dubuddy.in/"

export const S3_BUCKET =
  false && process.env.NODE_ENV === "development"
    ? "test-bucket-pancham1"
    : "cyberflow-dubuddy";
export const AWS_REGION = "ap-south-1";
export const IdentityPoolId =
  false && process.env.NODE_ENV === "development"
    ? "ap-south-1:050957c3-98f9-4d75-a32b-cb7053f6c7a1"
    : "ap-south-1:ab714953-0dd9-4fc8-a2f5-4b9bb9cb8990";

export const imageProvider = (url) => {
  if (url && url.startsWith("files/")) {
    return serverBaseUrl + url;
  }
  return url;
};
let store = createStore(RootReducer);
export const appToken = false && process.env.NODE_ENV === "development" ? "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdGF0dXMiOiJVTkJMT0NLRUQiLCJpZCI6MjgzLCJtb2JpbGUiOiIkMmIkMTAkYXlkVFVIVHlwUUZWdnpzcE4weTlvT21BM0cwREk4L3pBNUxoYko5anNzdXFOS1ZPMGhpTHUiLCJ1c2VyVHlwZSI6IkFETUlOIiwidXBkYXRlZEF0IjoiMjAyNS0wMi0yNlQwOTowNzoxNC41NzlaIiwiY3JlYXRlZEF0IjoiMjAyNS0wMi0yNlQwOTowNzoxNC41NzlaIiwiaWF0IjoxNzQwNTYwODM0LCJleHAiOjE3NDMxODg4MzQsImlzcyI6IkRVQnVkZHkifQ.i02si0so6Jc_Yt86Vr4ZqNOkVX8ri91A4W79ARbF4dE" : "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdGF0dXMiOiJVTkJMT0NLRUQiLCJpZCI6ODkyMjA2ODc5MCwibW9iaWxlIjoiJDJiJDEwJG43TEZEeTJSaXJEa1lYelNuSWlIcU90WlUzcC9SaU9jZUNmUWZLVzFQYzV6WWZabzRNZElpIiwidXNlclR5cGUiOiJBRE1JTiIsInVwZGF0ZWRBdCI6IjIwMjUtMDItMjZUMDk6MDg6MDIuNDkxWiIsImNyZWF0ZWRBdCI6IjIwMjUtMDItMjZUMDk6MDg6MDIuNDkxWiIsImlhdCI6MTc0MDU2MDg4MiwiZXhwIjoxNzQzMTg4ODgyLCJpc3MiOiJEVUJ1ZGR5In0.QzQhSkCs2juC-06HGHwBbXIDVTPLjv78715QMcXIROM"
export const dataLimit = 25;
export const commentLimit = 5;

export const theme = {
  primaryColor: "#fff",
  secondaryColor: "#000",
  appBackgroundColor: "#fff",
  accentColor: "#13b989",
  labelOrInactiveColor: "#D3D3D3",
  addMoreButtonColor: "#00CED1",
  greyColor: "#404040",
  redColor: "#FF0000",
  yellowColor: "#FFFF00",
  blueColor: "#4630EB",
  featureYesColor: "#07BD80",
  featureNoColor: "#FF0000",
  gradientColor: "#90EE90",
  lightGreenColor: "#ABE098",
  purpleColor: "#f4ebf9",
  darkPurpleColor: "#7859c5",
};

export const ImageResolver = (url) => {
  if (url && (url.startsWith("https://") || url.startsWith("http://"))) {
    return url;
  }
  return serverBaseUrl + url;
};
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
